import React from 'react';
import { usePricingFigures, usd } from '../../../hooks/usePricingFigures';
import { BriefPricingTable } from '../BriefPricingTable';

/** Option D: today's tier table with a thin fee strip above it. */
export function PricingTiersWithStrip({
  includeLeader
}: {
  includeLeader: boolean;
}) {
  const f = usePricingFigures(includeLeader);
  return <div data-id="element-870" data-mp="r8m5pfob7vb">
      <div className="mb-3 pb-2.5 flex flex-wrap items-baseline gap-x-7 gap-y-1 border-b border-[#33404a] text-[14px]" data-id="element-871" data-mp="pxh7mahru2m">
        {f.showImplementation && <span className="text-[#c5cdd3]" data-id="element-872" data-mp="357b3pdabqwwr">
            Implementation{' '}
            <span className="font-bold text-white" data-id="element-873" data-mp="397bjb195te5e">{usd(f.implementation)}</span>{' '}
            <span className="text-[#8e9aa4]" data-id="element-874" data-mp="3dyjv23xypblq">{f.implementationNote}</span>
            {f.promoDeadlineText && <span className="ml-2 font-bold text-[#6fd6b0]" data-id="element-875" data-mp="2hh73lfwchfai">
                {f.promoDeadlineText}
              </span>}
          </span>}
        <span className="text-[#c5cdd3]" data-id="element-876" data-mp="2lg61igjnsbsg">
          Placement bonus{' '}
          <span className="font-bold text-[#6fd6b0]" data-id="element-877" data-mp="10vwrygy3j8zf">{usd(f.bonus)} / rep</span>{' '}
          <span className="text-[#8e9aa4]" data-id="element-878" data-mp="vyeh2l0iqjos">{f.bonusNote}</span>
        </span>
        {f.retentionBonus > 0 && <span className="text-[#c5cdd3]" data-id="element-879" data-mp="r524j99463ce">
            Day-45 bonus{' '}
            <span className="font-bold text-[#6fd6b0]" data-id="element-880" data-mp="m8boun1819ri">
              {usd(f.retentionBonus)} / rep
            </span>{' '}
            <span className="text-[#8e9aa4]" data-id="element-881" data-mp="ha0gyhuhl9bx">{f.retentionNote}</span>
          </span>}
      </div>
      <BriefPricingTable hideFootnote data-id="element-882" data-mp="d5ammxfh82t4" />
    </div>;
}